module.exports = __webpack_public_path__ + "media/images/emblems/Uttigen-coat_of_arms-dbf59045f76a77c0c302d6ba61e2301f.svg";